import { RoverEnvironment } from '../Env/constants';

import { LogLevel, StatsigOptions } from './types';

const STATSIG_API_KEYS = {
  rxn_production: 'client-QaNCY4HS1v9OfZTsLHclrCOG5CPncfrsffjL7eLPglP',
  rxn_development: 'client-X9pOM9l97rKJKdymt3b9BV7hS7DvbdyqOPWZARhMwT7',
  rxn_staging: 'client-X6zCbpEmLbDjYEONybKQ70nFM5JAv0FrCeodrj5tIuc',
  react_production: 'client-fJ4xOQB9yzcuBdr4C9Lz4u69DEoWbsHuw8QEKo5NVX8',
  react_development: 'client-Cc1wjcgpZaTJEtboMT9BaBxSwBxmlVt1JUExYznKBsW',
  react_staging: 'client-6ndI2sgEXFnhGOfPupB3yR3lr5FzexDq8JYYrBEjYbP',
};

export enum StatsigPlatform {
  RXN = 'rxn',
  REACT = 'react',
}

export interface StatsigConfig {
  apiKey: string;
  clientOptions: StatsigOptions;
}

interface ProxyUrls {
  initializeUrl?: string;
  logEventUrl?: string;
}

const getProxyUrls = (platform: StatsigPlatform): ProxyUrls | null => {
  // Only use proxy for web client-side
  if (platform === StatsigPlatform.REACT && typeof window !== 'undefined') {
    const { origin } = window.location;
    return {
      initializeUrl: `${origin}/experimentation/init`,
      logEventUrl: `${origin}/experimentation/entry`,
    };
  }
  return null;
};

export const getStatsigConfig = (
  environment: RoverEnvironment,
  platform: StatsigPlatform
): StatsigConfig => {
  const apiKeyEnv = `${platform}_${environment}`;
  const apiKey = STATSIG_API_KEYS[apiKeyEnv];

  const proxyUrls = getProxyUrls(platform);

  const clientOptions: StatsigOptions = {
    environment: { tier: environment },
    logLevel: environment === RoverEnvironment.PRODUCTION ? LogLevel.None : LogLevel.Debug,
    ...(proxyUrls && {
      networkConfig: { ...proxyUrls },
    }),
  };

  return { apiKey, clientOptions };
};
